export class PartialRestoreData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "partialRestoreType",
            "baseName": "partialRestoreType",
            "type": "PartialRestoreType",
            "format": ""
        },
        {
            "name": "files",
            "baseName": "files",
            "type": "FileRestoreData",
            "format": ""
        },
        {
            "name": "awsEbsVolume",
            "baseName": "awsEbsVolume",
            "type": "AwsEbsVolumeRestoreData",
            "format": ""
        },
        {
            "name": "azureDisk",
            "baseName": "azureDisk",
            "type": "AzureDiskRestoreData",
            "format": ""
        },
        {
            "name": "gcpDisk",
            "baseName": "gcpDisk",
            "type": "GcpDiskRestoreData",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PartialRestoreData.attributeTypeMap;
    }
    constructor() {
    }
}
